export const VIDEO_MAIN_SET_INITIAL_TAB = 'VIDEO_MAIN_SET_INITIAL_TAB';